import * as React from 'react';

import { Alert, Typography } from 'antd';

const HELP_MIGRATION_URL = 'https://ajuda.eduzz.com/como-migrar-minhas-integrações-para-a-developer-hub-';

export default function WebhookInativationAlert() {
  const today = new Date();
  const inactivationDate = new Date('2026-04-30T23:59:59');

  if (today > inactivationDate) {
    return null;
  }

  return (
    <Alert
      type='warning'
      showIcon
      message='Chegou a hora de migrar para a Developer Hub!'
      description={
        <div className='flex flex-col gap-2'>
          <Typography.Paragraph className='mb-0'>
            O Webhook atual será descontinuado em 11/01/2027, e as integrações agora devem acontecer pela Developer Hub.
          </Typography.Paragraph>
          <Typography.Paragraph className='mb-0'>
            Com ela você ganha maior estabilidade, redisparo em massa de eventos com falha e um canal exclusivo para
            desenvolvedores.
          </Typography.Paragraph>
          <Typography.Paragraph className='mb-0'>
            Se sua conta ainda usa este webhook, recomendamos a migração o quanto antes para evitar impactos.
          </Typography.Paragraph>
          <Typography.Link href={HELP_MIGRATION_URL} target='_blank' rel='noopener noreferrer'>
            Saiba mais sobre o novo webhook e como migrar
          </Typography.Link>
        </div>
      }
    />
  );
}
